import { render, staticRenderFns } from "./ProjectManagementDeleteCardModal.vue?vue&type=template&id=c8266478&"
import script from "./ProjectManagementDeleteCardModal.vue?vue&type=script&lang=js&"
export * from "./ProjectManagementDeleteCardModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports